module.exports = __webpack_public_path__ + "static/img/homeTitle.a913af0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeTitle.png
// module id = wp+B
// module chunks = 0